"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isEmail = _interopRequireDefault(require("validator/lib/isEmail"));

var addStars = function addStars(str) {
  var leadChar = str.substring(0, 1);
  return leadChar.concat("***");
};

var maskEmail = function maskEmail(email) {
  if (!(0, _isEmail["default"])(email)) {
    return "***";
  }

  if (email.indexOf("*") !== -1) {
    return email;
  }

  var emailElements = email.split("@");
  var extensionPos = emailElements[1].indexOf(".");
  var maskedEmail = addStars(emailElements[0]).concat("@").concat(addStars(emailElements[1].substring(0, extensionPos))).concat(emailElements[1].substring(extensionPos));
  return maskedEmail;
};

var _default = maskEmail;
exports["default"] = _default;